import { render } from "./ImpuestoList.vue?vue&type=template&id=56e5c7a8&scoped=true"
import script from "./ImpuestoList.vue?vue&type=script&lang=js"
export * from "./ImpuestoList.vue?vue&type=script&lang=js"

import "./ImpuestoList.vue?vue&type=style&index=0&id=56e5c7a8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56e5c7a8"]])

export default __exports__